import { useTranslation } from 'react-i18next';

function ServiceNotAvailable() {
  const { t } = useTranslation();
  return (
    <div className="exercise-container" data-testid="service-not-available">
      <div className="content">
        <img src={process.env.PUBLIC_URL + '/images/p_logo.svg'} alt="P logo" className="logo" />
        <div className="body">
          <h1 className="title">{t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.TITLE')}</h1>
          <div>
            <p>{t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P1')}</p>
            <p>{t('EXERCISE_MANAGER.SERVICE_NOT_AVAILABLE.P2')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceNotAvailable;
